import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Reveal } from './Reveal';
import { FloatingMetalButton } from './FloatingMetalButton';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section className="relative pt-8 md:pt-12 pb-10 md:pb-14 px-[5vw] overflow-hidden" data-id="element-206">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-[15%] text-gold text-4xl opacity-80 pointer-events-none z-0" data-id="element-207">
        ◗
      </div>
      <div className="absolute bottom-40 left-[5%] text-green-soft text-2xl opacity-80 pointer-events-none z-0" data-id="element-208">
        ▽
      </div>

      {/* Dot Grid Pattern */}
      <div className="absolute bottom-20 right-[5%] opacity-50 pointer-events-none z-0" data-id="element-209">
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-210">
          <pattern id="dots" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-211">
            <circle cx="2" cy="2" r="2" fill="var(--green-soft)" data-id="element-212" />
          </pattern>
          <rect width="100" height="100" fill="url(#dots)" data-id="element-213" />
        </svg>
      </div>

      {/* Two-column layout */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center relative z-10" data-id="element-214">
        {/* Left Column — Text */}
        <div className="text-center lg:text-left" data-id="element-215">
          <Reveal data-id="element-216">
            <h1 className="font-serif font-bold text-[clamp(36px,5.5vw,76px)] leading-[1.05] tracking-[-0.03em] text-ink mb-6" data-id="element-217">
              Pare de{' '}
              <span className="relative inline-block" data-id="element-218">
                <span className="font-caveat text-rose text-[1.15em] relative z-10" data-id="element-219">
                  "achar"
                </span>
                <svg className="absolute w-full h-3 -bottom-1 left-0 z-0 text-rose" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-220">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="3" fill="none" data-id="element-221" />
                </svg>
              </span>
              . Saiba quanto cada produto seu dá de{' '}
              <span className="font-caveat text-gold text-[1.15em]" data-id="element-222">lucro</span>
              .
            </h1>
          </Reveal>

          <Reveal delay={0.2} data-id="element-223">
            <p className="text-[17px] leading-[1.6] text-ink-soft max-w-xl mx-auto lg:mx-0 mb-10" data-id="element-224">
              Te mostra na hora quanto cada produto seu{' '}
              <strong className="text-ink font-semibold" data-id="element-225">CUSTA</strong> de
              verdade, incluindo sua embalagem, decoração e tudo o que você
              esquece. Sem planilha. Sem Excel. Direto do celular.
            </p>
          </Reveal>

          <Reveal delay={0.3} data-id="element-226">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-227">
              <a href="#preco" className="cta-primary flex items-center gap-3 bg-[#E32F6E] text-white pl-8 pr-2 py-2.5 rounded-full hover:bg-[#c9275f] transition-all hover:scale-105 shadow-md w-full sm:w-auto justify-center no-underline" data-id="element-228">
                <span className="font-medium" data-id="element-229">Quero ver meu lucro real</span>
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-230">
                  <ArrowRight size={18} className="text-white" data-id="element-231" />
                </div>
              </a>
              <a href="#como-funciona" className="flex items-center justify-center px-8 py-3.5 rounded-full border-2 border-ink text-ink font-medium hover:bg-ink/5 transition-colors w-full sm:w-auto no-underline" data-id="element-232">
                Ver como funciona em 1 minuto
              </a>
            </div>
            <p className="text-[13px] text-ink-soft" data-id="element-233">
              Menos de R$1 por dia · Cancela quando quiser · 7 dias de garantia
              (devolvemos 100% se não funcionar)
            </p>
          </Reveal>
        </div>

        {/* Right Column — Mockups */}
        <div className="relative flex justify-center lg:justify-end" data-id="element-234">
          <div className="relative w-full max-w-[600px]" data-id="element-235">
            {/* Notebook Mockup */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.3,
            ease: [0.4, 0, 0.2, 1]
          }} data-id="element-236">
              <img src="https://cdn.magicpatterns.com/uploads/a5jKHjzM8VsyjDZdWyQrwv/Adobe_Express_-_file_(3).png" alt="Aurora Precificador — Dashboard no notebook" className="w-full h-auto rounded-lg" style={{
              filter: 'drop-shadow(0 32px 64px rgba(0,0,0,0.12))'
            }} data-id="element-237" />
            </motion.div>

            {/* Phone Mockup — overlapping */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.6,
            ease: [0.4, 0, 0.2, 1]
          }} className="absolute -bottom-12 -right-4 md:-right-12 w-[55%] md:w-[58%] z-20" style={{
            transform: 'rotate(-8deg)',
            filter: 'drop-shadow(0 24px 48px rgba(0,0,0,0.18))'
          }} data-id="element-238">
              <img src="https://cdn.magicpatterns.com/uploads/4AtoDZ25e6Sd3WFYKoTHBr/Adobe_Express_-_file_(4).png" alt="Aurora Precificador — App no celular" className="w-full h-auto rounded-2xl" data-id="element-239" />
            </motion.div>

            {/* Speech bubble next to phone */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8,
            x: 10
          }} animate={{
            opacity: 1,
            scale: 1,
            x: 0
          }} transition={{
            duration: 0.5,
            delay: 1.0,
            ease: [0.4, 0, 0.2, 1]
          }} className="absolute -bottom-4 right-[10%] md:right-[12%] z-30" data-id="element-240">
              <div className="relative bg-white rounded-2xl px-4 py-2.5 shadow-card" data-id="element-241">
                <span className="text-sm font-semibold text-ink whitespace-nowrap" data-id="element-242">
                  📱 Tudo na palma da sua mão
                </span>
                {/* Tail pointing left toward phone */}
                <div className="absolute top-1/2 -left-2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[8px] border-r-white" data-id="element-243"></div>
              </div>
            </motion.div>

            {/* Floating tag */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 1
          }} className="absolute top-6 -left-4 md:-left-8 bg-white px-4 py-2.5 rounded-xl shadow-card text-sm font-medium text-ink z-30" data-id="element-244">
              💸 Controle completo dos seus Custos
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 1.2
          }} className="absolute bottom-16 left-4 md:left-8 bg-green-soft px-4 py-2 rounded-xl shadow-card text-sm font-bold text-ink z-30" data-id="element-245">
              +23% vs mês anterior
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};